import SECTIONS from '~/scopes/campaign/data/metals/sections.translations'
import t from '~/scopes/campaign/data/metals/titanium.translations'

export default {
  name: t.name,
  smartphone: {
    label: t.smartphoneLabel,
  },
  whatItDoes: {
    text: t.whatItDoesText,
    sourceRefs: ['ademe2024', 'scrreenTitanium2025'],
  },
  extraction: [
    {
      text: t.extractionText1,
      sourceRefs: ['usgsMcs2025', 'scrreenTitanium2025'],
    },
  ],
  quickFact: {
    text: t.quickFactText,
    sourceRefs: ['scrreenTitanium2025'],
  },
  // Soil and climate read `n/a`, as do child labour, gender and legal rights
  // on the human side.
  impacts: {
    environmental: {
      summary: {
        text: t.envSummaryText,
        sourceRefs: [
          'ademe2024',
          'pblEnvironmental2024',
          'scrreenTitanium2025',
        ],
      },
      blocks: [
        {
          title: SECTIONS.environmentalWater,
          text: t.envWaterText,
          sourceRefs: ['pblEnvironmental2024', 'scrreenTitanium2025'],
        },
        {
          title: SECTIONS.environmentalBiodiversity,
          text: t.envBiodiversityText,
          sourceRefs: ['pblEnvironmental2024', 'scrreenTitanium2025'],
        },
      ],
    },
    human: {
      summary: {
        text: t.humanSummaryText,
        sourceRefs: ['scrreenTitanium2025'],
      },
      blocks: [
        {
          title: SECTIONS.humanDisplacement,
          text: t.humanDisplacementText,
          sourceRefs: ['scrreenTitanium2025'],
        },
        {
          title: SECTIONS.humanWaterRights,
          text: t.humanWaterText,
          sourceRefs: ['scrreenTitanium2025'],
        },
        {
          title: SECTIONS.humanHealth,
          text: t.humanHealthText,
          sourceRefs: ['scrreenTitanium2025'],
        },
      ],
    },
    geopolitical: {
      summary: {
        text: t.geoSummaryText,
        sourceRefs: ['usgsMcs2025', 'euCrma2024', 'scrreenTitanium2025'],
      },
      blocks: [
        {
          title: SECTIONS.geopoliticalDug,
          text: t.geoDugText,
          sourceRefs: ['usgsMcs2025'],
        },
        {
          title: SECTIONS.geopoliticalProcessed,
          text: t.geoProcessedText,
          sourceRefs: ['scrreenTitanium2025'],
        },
        {
          title: SECTIONS.geopoliticalLeverage,
          text: t.geoLeverageText,
          sourceRefs: [
            'usgsMcs2025',
            'ieaGcmo2025',
            'euCrma2024',
            'scrreenTitanium2025',
          ],
        },
      ],
    },
  },
  supplyRisk: {
    summary: {
      text: t.supplySummaryText,
      sourceRefs: ['ieaGcmo2025', 'scrreenTitanium2025'],
    },
    blocks: [
      {
        title: SECTIONS.supplyRiskReserves,
        text: t.supplyReservesText,
        sourceRefs: ['usgsMcs2025'],
      },
      {
        title: SECTIONS.supplyRiskDemand,
        text: t.supplyDemandText,
        sourceRefs: [
          'ieaGcmo2025',
          'ieaMineralsExplorer',
          'scrreenTitanium2025',
        ],
      },
    ],
  },
  recycling: {
    summary: {
      text: t.recyclingSummaryText,
      sourceRefs: ['scrreenTitanium2025'],
    },
    blocks: [
      {
        title: SECTIONS.recyclingInput,
        text: t.recyclingInputText,
        sourceRefs: ['unepRecyclingRates2011', 'scrreenTitanium2025'],
      },
      {
        title: SECTIONS.recyclingOutlook,
        text: t.recyclingOutlookText,
        sourceRefs: [
          'ieaRecycling2024',
          'unepRecyclingRates2011',
          'scrreenTitanium2025',
        ],
      },
    ],
  },
  // `*` on the four scores it names; recycling carries none.
  footnotes: [
    {
      body: [
        {
          text: t.footnote1Text1,
          sourceRefs: ['ademe2024'],
        },
      ],
      slots: [
        'environmentalScore',
        'humanScore',
        'geopoliticalScore',
        'supplyRiskScore',
      ],
    },
  ],
} as const
